import { gql } from "@apollo/client";

export const GET_TALONARIOS_RI_EV = gql`
query getTalonariosRIEV($filter: TalonarioRIEVFilterInput!){
    talonariosRIEV (filter: $filter) {    
        success,
        error,
        valorEsperado {
            idEvolucion,
            talonarios {
                nroTalonario
            }
        }
    }
  }
`;